<template>
  <div class="px-3 py-4">
    <h3 class="text-header">
      Receiver <tool-tip text="Recipient of the goods being shipped." />
    </h3>

    <div class="w-full flex mt-1 gap-4 pt-3 pb-2 mb-2">
      <label :for="'noEnd'" class="radio-label pr-10">
        <input
          class="bg-primary-yellow text-secondary-yellow"
          :name="'routeEnd'"
          type="radio"
          :id="'noEnd'"
          value="business"
          v-model="reciever.customerType"
        />
        Business Customer
        <span></span>
      </label>

      <label :for="'yesEnd'" class="radio-label">
        <input
          type="radio"
          v-model="reciever.customerType"
          value="private"
          :id="'yesEnd'"
          :name="'routeEnd'"
        />
        Private Customer
        <span></span>
      </label>
    </div>

    <div class="flex flex-wrap pt-0 justify-between">
      <div class="slice-option sm:w-5/12 w-full">
        <label class="label">Name</label>
        <input
          type="text"
          class="input-mini"
          placeholder="--Enter--"
          v-model="reciever.contactName"
        />
      </div>
      <div
        class="slice-option sm:w-5/12 w-full"
        v-if="reciever.customerType != 'private'"
      >
        <label class="label">Contact Person</label>
        <input
          type="text"
          class="input-mini"
          placeholder="--Enter--"
          v-model="reciever.contactPerson"
        />
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <label class="label">Email</label>
        <input
          type="text"
          class="input-mini"
          placeholder="--Enter--"
          v-model="reciever.email"
        />
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <div class="flex justify-between items-center">
          <label class="label whitespace-no-wrap">Phone Number</label>
          <div class="w-full flex mt-1 gap-4 justify-end">
            <label for="firstPhone" class="radio-label">
              <input
                class="bg-primary-yellow text-secondary-yellow"
                name="phone"
                type="radio"
                id="firstPhone"
                value="mobile"
                v-model="reciever.mobileNumberType"
              />
              Mobile
              <span></span>
            </label>

            <label for="lastPhone" class="radio-label sm:w-5/12 w-full">
              <input
                type="radio"
                v-model="reciever.mobileNumberType"
                value="fixed"
                id="lastPhone"
                name="phone"
              />
              Fixed
              <span></span>
            </label>
          </div>
        </div>
        <vue-tel-input v-model="reciever.mobile" class="py-0"></vue-tel-input>
        <span v-if="isPhoneNumberInValid" class="mt-2 text-red-500 inline-block">Phone number is invalid</span>
      </div>

      <div class="slice-option sm:w-5/12 w-full">
        <div class="flex justify-between items-center">
          <label class="label whitespace-no-wrap">Address</label>
          <div class="w-full flex mt-1 gap-4 justify-end">
            <label for="firstAddress" class="radio-label">
              <input
                class="bg-primary-yellow text-secondary-yellow"
                name="first"
                type="radio"
                id="firstAddress"
                value="residential"
                v-model="reciever.addressType"
              />
              Residential
              <span></span>
            </label>

            <label for="lastAddress" class="radio-label">
              <input
                type="radio"
                v-model="reciever.addressType"
                value="business"
                id="lastAddress"
                name="first"
              />
              Business
              <span></span>
            </label>
          </div>
        </div>
         <Addressinput class="address_input w-full" placeholder="--Enter Address--" :locationDetails="viewLocationDetails" :value="selectTerminal"/>
      </div>

      <div class="w-full pb-10 mt-3">
        <hr />
        <div class="mt-6 flex justify-between items-center">
          <b class="inline-block">Delivery Info</b>
          <button
            @click="showDeliveryInfo = !showDeliveryInfo"
            v-html="
              showDeliveryInfo
                ? '&HorizontalLine;'
                : `<abbr class='text-xl'>&plus;</abbr>`
            "
          ></button>
        </div>
      </div>

      <div class="lg:w-5/12 w-full pb-10 mt-3" v-show="showDeliveryInfo">
        <div class="w-full flex mt-1 gap-4 justify-start">
          <label for="deleiverAtTerminal" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="recieverShippingMethod"
              type="radio"
              id="deleiverAtTerminal"
              value="deliver-off at Terminal"
              v-model="recieverShippingMethod"
            />
            Receiver will pick from terminal
            <span></span>
          </label>

          <label for="deliverAtAddress" class="radio-label">
            <input
              type="radio"
              v-model="recieverShippingMethod"
              value="deliver to adddress"
              id="deliverAtAddress"
              name="recieverShippingMethod"
            />
            Deliver to receiver’s address
            <span></span>
          </label>
        </div>

        <el-date-picker
          v-show="recieverShippingMethod != 'deliver-off at Terminal'"
          placeholder="Select preferred delivery date/time"
          class="w-full full-width"
          v-model="reciever.pickUpDays"
          type="date"
          :picker-options="{
            disabledDate: (time) => disabledEndDate(time, null),
          }"
        ></el-date-picker>
      </div>

      <div class="lg:w-5/12 w-full py-3" v-show="showDeliveryInfo">
        <base-checkbox
          v-model="reciever.sendShippingUpdates"
          label="Send me status updates regarding my shipment with the email provided."
        />
      </div>

      <AddReciever
        @setWithPreviousReciever="setWithPreviousReciever"
        :showModal="showNewBookingModal"
        @close-modal="showNewBookingModal = false"
      />

      <div class="flex w-full items-center justify-between py-4 px-4">
        <button @click="$emit('changeBookingTab', 1)" class="underline">
          Back
        </button>

        <primary-button
          class="shadow-md font-normal"
          buttonText="Continue"
          :loading="loading"
          :disabled="isDisabled"
          @click="submitConsignee"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddReciever from "../modals/AddReciever.vue";
import Addressinput from "../../UI/Addressinput.vue";
import moment from "moment";

export default {
  components: {
    AddReciever,
    Addressinput
  },
  data() {
    return {
      showNewBookingModal: !this.$store.getters.latestNewBooking?.consignee
        ?.address?.name
        ? true
        : false,
      shippingService: [],
      loading: false,
      pickUp: undefined,
      pickUpDays: undefined,
      changeAddress: false,
      recieverShippingMethod: "deliver to adddress",
      showDeliveryInfo: true,
      reciever: {
        address: {
          lat: "",
          lng: "",
          name: "",
        },
        terminalAdd: {
          lat: "",
          lng: "",
          name: "",
          locality: "",
          country: "",
          street_number: "",
        },
        alternativeAddress: {},
        type: "delivery",
        id: undefined,
        pickUp: undefined,
        pickUpDays: undefined,
        mobileNumberType: "mobile",
        addressType: "residential",
        customerType: "business",
        contactName: undefined,
        contactPerson: undefined,
        shippingMethod: undefined,
        email: undefined,
        mobile: '',
        sendShippingUpdates: false,
        shipmentStates: {},
      },
    };
  },
  watch: {
    recieverShippingMethod(val) {
      val != "Pick-up from Terminal"
        ? (this.reciever.pickUp = undefined)
        : (this.pickUpDays = undefined);
      switch (val) {
        case "deliver to adddress":
          this.reciever.alternativeAddress = {};
          break;

        case "deliver-off at Terminal":
          this.reciever.pickUpDays = undefined;
          this.reciever.alternativeAddress = {
            lat: this.reciever.address.lat,
            lng: this.reciever.address.lng,
            name: this.fullAddress,
          };
          break;
      }
    },
  },
  activated() {
    this.getAllTerminalLocation();
  },
  mounted() {
    let prevReciever = this.$store.getters.latestNewBooking.consignee;
    if (!prevReciever) return;

    const cloneReciever = {
      address: {
        lat: prevReciever?.address?.lat,
        lng: prevReciever?.address?.lng,
        name: prevReciever?.address?.name,
      },
      email: prevReciever?.email,
      addressType: prevReciever?.addressType,
      mobileNumberType: prevReciever?.mobileNumberType,
      mobile:
        prevReciever?.mobile_no || prevReciever?.mobile_no != ""
          ? prevReciever?.mobile_no
          : prevReciever?.mobile,
      contactPerson: prevReciever.contactPerson,
      contactName: prevReciever.contactName,
    };

    this.reciever = {
      ...this.reciever,
      ...cloneReciever,
    };
  },
  computed: {
    isPhoneNumberInValid(){
      let trimTel = this.reciever.mobile.replace(/ /g, "")
      return (this.reciever?.mobile != "" && trimTel.length < 11) || (this.reciever?.mobile != "" && trimTel.length > 11)
    },
    customStyle(){
       return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: '1px solid grey'
       }
    },

    checkTerminalType() {
      let start = this.activeShipping?.shipper?.dropOff ? "terminal" : "door";
      let end = this.activeShipping?.consignee?.pickUp ? "terminal" : "door";
      return `${start}-to-${end}`;
    },
    selectTerminal() {
      return this.reciever.address;
    },
    activeShipping() {
      return this.$store.getters.latestNewBooking;
    },
    isTerminal() {
      return this.recieverShippingMethod == "deliver-off at Terminal";
    },
    fullAddress() {
      return this.extractAddress(this.reciever.address);
    },
    recieverPayload() {
      return {
        ...this.reciever,
        email: this.reciever.email || 'support@muleex.com',
        isTerminal:
          this.recieverShippingMethod != "Deliver to receivers addres",
        shippingMethod: `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`,
        // pickUpDays: !this.isTerminal ? [this.reciever.pickUpDays.split('T')[0]] : undefined,
        deliveryDays: this.$store.state.latestNewBooking?.dropOffDays,
        pickUpDays: this.reciever.pickUpDays
          ? moment(this.reciever.pickUpDays).format("yyyy-MM-DD")
          : this.reciever.pickUpDays,
      };
    },
    isDisabled() {
      return (
        !this.reciever.mobile ||
        !this.reciever.address.lat ||
        (!this.isTerminal && !this.reciever.pickUpDays)
        || this.isPhoneNumberInValid
      );
    },
    payload() {
      let cogID = this.$store.getters.latestNewBooking.consignee.id;
      let shipID = this.$store.getters.latestNewBooking.shipper.id;
      console.log('reciever', this.reciever)
      return {
        paymentStatus: "Not paid",
        shippingServiceId: null,
        consigneeLocationId: cogID,
        shipperLocationId: shipID,
        deliveryConfirmation: false,
        currentStep: 2,
        id: this.$store.getters.latestNewInitialShipping?.id,
        shippingMethod: `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`,
        pickUpDays:
          this.pickUpDays && this.pickUpDays.length
            ? [this.pickUpDays.split("T")[0]]
            : undefined,
            // dropOff: moment(this.$store.state.senderDropDate).format('MM-DD-YYYY'),
            // pickUp: moment(this.reciever.pickUpDays).format('MM-DD-YYYY'),
        deliveryDays: this.$store.state.latestNewBooking?.dropOffDays,
        transitState: this.shipmentStates,
      };
    },
  },
  methods: {
    viewLocationDetails(response){
       const addressData = {
        route: response?.name,
        latitude: response?.lat,
        longitude: response?.lng
      }
       this.setAddress(addressData)
    },
    disabledEndDate(date, departureDate = new Date()) {
      // If departureDate then return valid dates after departureDate
      if (departureDate) {
        return date.getTime() < departureDate;
      } else {
        // If !departureDate then return valid dates after today
        return date.getTime() < Date.now() - 8.64e7;
      }
    },
    async getUserLocation(event) {
      if (!event) return;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          successCallback.bind(this),
          errorCallback
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }

      function successCallback(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        this.sender.terminalAdd = {
          ...this.reciever.terminalAdd,
          lat: latitude,
          lng: longitude,
        };
      }

      function errorCallback() {
        this.handleError("Error getting location");
      }
    },
    setuserShippingMethod() {
      // let getmethods = this.$store.getters.getBookingShippingMethod
      let getmethods = this.isTerminal ? "terminal" : "door";
      this.$store.dispatch("saveBookingMethodEnd", getmethods);
      this.shippingMethod = `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
    },
    async getStateName() {
      let shipping = await this.$store.getters.latestNewBooking;
      const senderPayload = {
        lat:
          shipping.consignee.alternativeAddress.lat ||
          shipping.consignee.address.lat,
        long:
          shipping.consignee.alternativeAddress.lng ||
          shipping.consignee.address.lng,
      };
      const recieverPayload = {
        lat: shipping.shipper.address.lat,
        long: shipping.shipper.address.lng,
      };

      let state_Obj = {};

      await this.$_getStateNameWithDim(senderPayload).then(
        (res) => (state_Obj.sender = res.data.state)
      );

      await this.$_getStateNameWithDim(recieverPayload).then(
        (res) => (state_Obj.reciever = res.data.state)
      );

      this.$store.dispatch("saveBookingStates", state_Obj);
      this.shipmentStates = state_Obj;
    },
    returnML(val) {
      return val?.locationName + " (" + val?.Org?.companyname + ")";
    },
    async getAllTerminalLocation() {
      try {
        this.$_newGetAllBookingLocations().then((response) => {
          this.allterminals = response.data.findLocation;
        });
      } catch (error) {
        //
      }
    },
    setWithPreviousReciever(val) {
      const cloneReciever = {
        address: {
          lat: val?.address?.lat,
          lng: val?.address?.lng,
          name: val?.address?.name,
          street_number: val?.address?.street_number,
          locality: val?.address?.locality,
          country: val?.address?.country,
        },
        email: val?.email,
        addressType: val?.addressType,
        mobileNumberType: val?.mobileNumberType,
        mobile: val?.mobile || val?.mobile != "" ? val?.mobile : val?.mobile_no,
        contactPerson: val.contactPerson,
        contactName: val.contactName,
      };
      this.reciever = {
        ...this.reciever,
        ...cloneReciever,
      };
    },
    setAddress(addressData) {
      this.reciever = {
        ...this.reciever,
        address: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
          street_number: addressData?.street_number,
          locality: addressData?.locality,
          country: addressData.country,
          adm_1: addressData?.administrative_area_level_1,
          adm_2: addressData?.administrative_area_level_2,
        },
      };
    },
    setTerminal(addressData) {
      this.sender = {
        ...this.reciever,
        alternativeAddress: {
          name: addressData?.route,
          lat: addressData?.latitude,
          lng: addressData?.longitude,
        },
      };
    },
    async createShipping() {
      console.log('store', this.$store.state)
      try {
        let response = await this.$_createShippingId({
          payload: { ...this.payload },
        });
        this.$store.dispatch(
          "saveLatestNewInitialShipping",
          response.data.data.shipping
        );
        await this.getShippingService();
      } catch (error) {
        this.handleError(error);
      }
    },
    async getShippingService() {
      try {
        let payload = {
          shipperLocationId: this.$store.getters.latestNewBooking.shipper?.id,
          consigneeLocationId: this.$store.getters.latestNewBooking.consignee
            ?.id,
          shippingId: this.$store.getters.latestNewInitialShipping?.id,
          shipmentType: "single",
          terminalType: this.shippingMethod,
        };
        await this.newGetShippingServiceByRoute(payload).then(
          async (response) => {
            this.shippingService = response.data.data.shippingServices.filter(
              (item) => item
            );
            // await this.getStateName();
            // const shippingMethod = `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
            // const states = this.$store.getters.getBookingStates;
            // const checktype =
            //   states.reciever === states.sender &&
            //   shippingMethod !== "terminal-to-terminal";
            // console.log(">>>>>>>>>>>>>>>>>>", shippingMethod, states, checktype)
            // if (!checktype) {
            //   !checktype &&
            //     this.generateToast(
            //       "Can`t proceed no shipping service available, for the chosen route",
            //       "error"
            //     );
            //   return;
            // }
            this.$emit("changeBookingTab", 3);
          }
        );
      } catch (error) {
        this.handleError(error);
      }
    },
    async submitConsignee() {
      this.loading = true;
      this.setuserShippingMethod();
      try {
        delete this.reciever.phoneType;
        delete this.reciever.addressType;

        const statePayload = { lat: this.reciever?.address?.lat, long: this.reciever?.address?.lng}
        const state = await this.$_getStateNameWithDim(statePayload)

        const address = {
          ...this.recieverPayload.address,
          state: state.data?.state,
          city: state.data?.address?.city
        }
       this.recieverPayload.address = address
       
        const recieverPayload = {
          ...this.recieverPayload,
          state: state.data?.state,
          city: state.data?.address?.city
        }

        const response = !this.reciever?.id
          ? await this.$_submitConsigneeInformation(recieverPayload)
          : await this.$_updateBookngLodation(recieverPayload);
        this.$store.dispatch(
          "saveLatestNewBookingConsignee",
          response.data.data.location || response.data.data
        );
        const recieverResponse =
          response.data.data.location || response.data.data;
        this.reciever.id = recieverResponse.id;
        this.$store.dispatch("saveBookingChangesIndicator", true);
        await this.createShipping();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-header {
  font-size: 24px;
  font-weight: 500;
  @apply py-4;
}
.slice-option {
  @apply mt-8;
}
.input-mini {
  @apply bg-gray-100 w-full py-2 px-2 border-2 border-gray-300 rounded-md;
}
.label {
  @apply w-full block;
}
.el-date-editor {
  width: 100%;
}
</style>
